import { useTheme } from "@mui/material";
import FoldersAM from "../FoldersAM";
import SecondaryButton from "../../../buttons/SecondaryButton";
import { PhotoControlFacadeFolder } from "../../../folder_modals/PhotoControlFacadeFolder";
import TimelineFolder from "../../../folder_modals/TimelineFolder";
import Icon1 from "../../../icons/Icon";
import Space from "../../../layout/Space";
import { intToHexColor, isColorTooDark } from "../../../models/OrgFunctions";
import { getOrRefreshFirebaseToken } from "../../../config/getFirebaseToken";
import updateDocDataFieldApi from "../../../api/database/updateDocDataFieldApi";
import { addActivityLog } from "../../../config/OnlineStatus";
import deleteFolder from "../../../api/delete/deleteFolder";
import { useState } from "react";
import { getPartnerTypeName } from "../../Partner";
import { FolderTypeIcon, isFolderAdmin } from "../FolderHelpers";
import Tippy from "@tippyjs/react";
import TimelineFolderAudit from "../../../folder_modals/TimelineFolderAudit";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
} from "../../../models/DataFunctions";
import { particulierActivated } from "../../../hexagone/VisibilityHelpers";

export const FolderHeader = ({
  setEmailOpen,
  setEmailForXml,
  setEmailModifThermal,
  setEmailForExpert,
  handleSetEmailModalOpen,
  all_repertories,
  setAllRepertories,
  navigateWorkspace,
  userData,
  orgData,
  folderData,
  handleFetchData,
  actions,
  vision,
  tags,
  clientData,
  all_blocked = false,
  isHovered = null,
  setIsHovered = () => {},
  handleOpenTag = () => {},
  handleClickVariant,
  prefix,
  workspaceData,
  id,
  masterData,
  handleSetReglementDone,
  carnetDetails = null,
  setMissingDocNames,
  setMissingDocIds,
}) => {
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingUnblock, setLoadingUnblock] = useState(false);

  // Mirrors DocumentCell.handleBlock: a "blocked" document goes back to "wait"
  // when it already has files, "locked" otherwise. Unblocks every blocked
  // document of the folder at once, then clears folder.blocked.
  const handleUnblockFolder = async () => {
    if (loadingUnblock) return;
    setLoadingUnblock(true);
    try {
      const unblockedState = (obj) =>
        obj?.files?.length > 0 ? "wait" : "locked";
      const updates = [];
      for (const key of [
        "thermal",
        "xml",
        "modif_thermal",
        "rapport",
        "rapport_architecte",
      ]) {
        if (folderData[key]?.state === "blocked") {
          updates.push(
            updateDocDataFieldApi(
              folderData.ref,
              key + ".state",
              unblockedState(folderData[key]),
              prefix
            )
          );
        }
      }
      if (folderData.modif_thermal?.xml?.state === "blocked") {
        updates.push(
          updateDocDataFieldApi(
            folderData.ref,
            "modif_thermal.xml.state",
            unblockedState(folderData.modif_thermal.xml),
            prefix
          )
        );
      }
      const documents = await getArrayDocDataByRef(folderData.documents || []);
      for (const doc of documents) {
        if (doc.state === "blocked") {
          updates.push(
            updateDocDataFieldApi(doc.ref, "state", unblockedState(doc), prefix)
          );
        }
      }
      await Promise.all(updates);
      await updateDocDataFieldApi(folderData.ref, "blocked", false, prefix);
      handleClickVariant("Dossier débloqué", "success");
      handleFetchData();
    } catch (e) {
      handleClickVariant("Impossible de débloquer le dossier", "error");
    } finally {
      setLoadingUnblock(false);
    }
  };

  const godeleteFolder = async () => {
    setLoadingDelete(true);
    const token = await getOrRefreshFirebaseToken();
    let matching_invoice = folderData.invoices?.find((invoice) => invoice.ref);
    if (matching_invoice) {
      await updateDocDataFieldApi(
        matching_invoice.ref,
        "folder_ref",
        null,
        prefix
      );
    }
    await addActivityLog(
      "Dossier supprimé",
      folderData.ref,
      orgData.id,
      userData.id,
      "folder_deleted",
      prefix
    );
    await deleteFolder(id, token, prefix);
    navigateWorkspace("/folders");
    handleClickVariant("Dossier supprimé", "success");
  };

  const gotoFolders = () => {
    navigateWorkspace("/folders");
  };
  const handleImpersonateParticulier = async () => {
    navigateWorkspace("/imp-portal/folderportal/" + id, null, null);
  };

  const handleImpersonate = async () => {
    if (!clientData) {
      handleClickVariant("Aucun client trouvé", "error");
      return;
    }
    if (clientData.email === "william.bresso@gmail.com") {
      handleClickVariant(
        "Impersonation désactivée pour cette organisation",
        "error"
      );
      return;
    }
    if (!clientData.users_id || clientData.users_id.length === 0) {
      handleClickVariant("Aucun utilisateur trouvé", "error");
      return;
    }
    let client_user_id = clientData.users_id[0];
    let workspaces_ref = clientData.workspaces_id || [];
    let workspaces = await getArrayDocDataByID("workspace", workspaces_ref);
    let my_workspace = workspaces.find(
      (workspace) => workspace.master_id === orgData.id
    );
    if (!my_workspace) {
      handleClickVariant("Aucun workspace trouvé", "error");
      return;
    }
    navigateWorkspace(
      "/imp/" +
        client_user_id +
        "/workspace/" +
        my_workspace.id +
        "/folder/" +
        id,
      clientData,
      my_workspace.id
    );
  };

  const gomodifyFolder = () => {
    navigateWorkspace("/modifyfolder/" + id);
  };
  const theme = useTheme();

  return (
    <div className=" flex flex-col">
      <div className="flex flex-col">
        <div className="w-full flex flex-row ">
          <div
            className="w-full cursor-pointer flex flex-row"
            onClick={gotoFolders}
          >
            <div className="text-h2 font-semibold text-primary_l bg-transparent">
              Dossiers
            </div>
            <Icon1 icon_name="right" height="15px"></Icon1>
          </div>

          <div className="flex w-fit min-w-fit gap-2">
            {isFolderAdmin(orgData, folderData) &&
              particulierActivated(folderData) && (
                <>
                  <SecondaryButton
                    className="w-fit"
                    onClick={() => {
                      handleImpersonateParticulier();
                    }}
                  >
                    Vue particulier
                  </SecondaryButton>
                </>
              )}
            {isFolderAdmin(orgData, folderData) &&
              folderData.client_type !== "particulier" && (
                <>
                  <SecondaryButton
                    className="w-fit"
                    onClick={() => {
                      handleImpersonate();
                    }}
                  >
                    Vue client
                  </SecondaryButton>
                </>
              )}
            {isFolderAdmin(orgData, folderData) && (
              <>
                <SecondaryButton
                  className="w-fit"
                  onClick={() => {
                    setEmailOpen(true);

                    setEmailForXml(false);
                    setEmailModifThermal(false);
                    setEmailForExpert(false);
                  }}
                >
                  Notifier votre partenaire
                </SecondaryButton>
              </>
            )}
            <FoldersAM
              userData={userData}
              actionModify={gomodifyFolder}
              actionDelete={godeleteFolder}
              orgData={orgData}
              folder={folderData}
              forcePageReload={handleFetchData}
              loadingDelete={loadingDelete}
              handleSetEmailModalOpen={handleSetEmailModalOpen}
              all_repertories={all_repertories}
              setAllRepertories={setAllRepertories}
              navigateWorkspace={navigateWorkspace}
              id={folderData.id}
              workspaceData={workspaceData}
              masterData={masterData}
              handleSetReglementDone={handleSetReglementDone}
              carnetDetails={carnetDetails}
              setMissingDocNames={setMissingDocNames}
              setMissingDocIds={setMissingDocIds}
            />
          </div>
        </div>
        <PhotoControlFacadeFolder
          folderData={folderData}
          prefix={prefix}
        ></PhotoControlFacadeFolder>
        <div className="text-hx2 font-semibold gap-2 mt-4 items-center flex flex-row ">
          {folderData?.nom}
          {folderData?.carnet_id && (
            <Icon1 icon_name="hexagone-logement" size={20}></Icon1>
          )}
        </div>
        <div className="text-hx  gap-2 mt-1 items-center flex flex-row ">
          <span className="text-h3 text-shadow_50">
            {folderData?.num?.length > 1 ? folderData?.num : ""}
          </span>
        </div>
        <div className="text-hx font-semibold gap-1 flex flex-row mt-3 ">
          <div className="flex flex-row rounded-xl items-center text-shadow_50 bg-shadow_5 px-2 text-h2 font-semibold w-fit">
            {vision &&
              (vision.state === "archived"
                ? "Archivé"
                : folderData.intervention_realisee
                  ? "Réalisé"
                  : "A venir")}
          </div>{" "}
          <div
            className={`inline-flex h-6 text-h2 font-light items-center rounded-lg px-2 py-2 flex-row border
              ${
                folderData.partner_type === "particulier"
                  ? "text-violet-400  bg-violet-50 "
                  : folderData.payment_allowed === true
                    ? "text-blue-400  bg-blue-50 "
                    : "text-indigo-400  bg-indigo-50 "
              }
               `}
          >
            {folderData.partner_type !== "particulier"
              ? (folderData?.marque || folderData?.folder_entreprise_name) + " "
              : ""}

            <span
              className={`${folderData.partner_type !== "particulier" ? "ml-2" : ""} text-h3  font-semibold`}
            >
              {getPartnerTypeName(folderData.partner_type)}
            </span>
          </div>
        </div>
        <Space y={5} />

        <div className=" flex flex-row gap-2 items-center ">
          {" "}
          {tags && (
            <div className="flex flex-wrap space-x-1">
              {tags.map((tag, index) => (
                <div
                  className="w-fit h-5 flex"
                  key={index}
                  onClick={() =>
                    tag.org_id === orgData.id && handleOpenTag(index)
                  }
                  onMouseEnter={() => setIsHovered(index)}
                  onMouseLeave={() => setIsHovered(null)}
                >
                  <div
                    className={`  inline-flex items-center rounded-full h-full px-2 text-h3 cursor-pointer`}
                    style={{
                      backgroundColor:
                        isHovered === index
                          ? theme.palette.shadow._10
                          : intToHexColor(tag?.colorint),
                      color:
                        isHovered === index
                          ? theme.palette.shadow._25
                          : isColorTooDark(intToHexColor(tag?.colorint))
                            ? "white"
                            : "black",
                    }}
                  >
                    {tag.nom}
                  </div>
                </div>
              ))}

              <div
                onClick={() => handleOpenTag(tags.length)}
                className=" h-5  text-h3  items-center text-shadow_25 bg-neutral-50 hover:bg-neutral-200 hover:text-shadow_25 rounded-full px-2  cursor-pointer"
              >
                Ajouter
              </div>
            </div>
          )}
          {folderData.reglement_state !== "done" && actions > 0 && (
            <div className="text-h3 h-5 items-center">
              <div
                className="inline-flex items-center rounded-full h-full px-2 py-1 text-white"
                style={{
                  backgroundColor: theme.palette.accent2.main, // dynamically set the background color
                }}
              >
                {actions + (actions > 1 ? " actions" : " action")}
              </div>
            </div>
          )}{" "}
          {folderData.reglement_state === "done" &&
            folderData.conforme !== false && (
              <div className="text-h3 h-5 items-center">
                <div className="inline-flex items-center rounded-full h-full px-2 py-1 text-white bg-green-400">
                  finalisé
                </div>
              </div>
            )}
          {folderData.conforme === false && (
            <div className=" h-5 inline-flex items-center rounded-full text-h3 px-2 py-1 text-white bg-indigo-400">
              non conforme
            </div>
          )}
          {folderData.revisions?.length === 0 && (
            <div className="inline-flex  text-h3 h-5 items-center rounded-full px-2 py-1 text-white bg-amber-400">
              revisite
            </div>
          )}
          {folderData.reglement?.state === "wait" && (
            <div className="inline-flex  text-h3 h-5 items-center rounded-full px-2 py-1 text-white bg-orange-400">
              paiement
            </div>
          )}
          {folderData.blocked && (
            <Tippy
              className="custom-tooltip"
              content="Cliquer pour débloquer le dossier (enlève le marquage « impossible à déposer » de tous les documents)"
              placement="top"
              delay={300}
            >
              <div
                onClick={handleUnblockFolder}
                className={`inline-flex  text-h3 h-5 items-center rounded-full px-2 py-1 text-white bg-red-400 cursor-pointer hover:bg-red-500 ${loadingUnblock ? "opacity-50" : ""}`}
              >
                {loadingUnblock ? "déblocage..." : "bloqué"}
              </div>
            </Tippy>
          )}
          {folderData.late && (
            <div className="text-h3 h-5 items-center">
              <div className="inline-flex items-center rounded-full h-full px-2 py-1 text-white bg-red-400">
                retard
              </div>
            </div>
          )}
        </div>

        {all_blocked && isFolderAdmin(orgData, folderData) && (
          <div className="bg-red-50 border-l-2 border-red-400 mt-4 rounded-xl p-3 text-red-500 text-h2 w-fit flex flex-col mb-6">
            <div className="flex flex-row items-center gap-4">
              <Icon1 icon_name="warning" size={20} fill="red"></Icon1>
              <div className="flex flex-col gap-1">
                <div>
                  Un des partenaires du dossier n'a accès à aucun document.
                </div>
                <div>
                  Veuillez modifier les accès du dossier en allant dans l'onglet
                  <span className="font-bold"> Accès</span> ci-dessous.
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Space y={40} />
      {folderData.folder_type === "infiltro" && (
        <TimelineFolder
          folderData={folderData}
          clientData={clientData}
        ></TimelineFolder>
      )}
      {folderData.folder_type === "audit" && (
        <TimelineFolderAudit
          folderData={folderData}
          orgData={orgData}
          handleFetchData={handleFetchData}
          prefix={prefix}
          handleClickVariant={handleClickVariant}
        ></TimelineFolderAudit>
      )}
      <Space y={40} />
    </div>
  );
};
